import { FieldValues, KeepStateOptions } from 'react-hook-form';
import { HookFormCustomType } from '../types';

export const makeFormOptionsOverride = <TFieldValues extends FieldValues>(
  props: any
): HookFormCustomType<TFieldValues> => {
  // Only set default mode if not provided by user
  if (!props.mode) {
    props.mode = 'onBlur';
  }
  props.criteriaMode = 'firstError';
  props.shouldFocusError = false;
  props.reValidateMode = props.mode; // Use same mode for revalidation
  props.resetOptions = {
    keepDirtyValues: false,
    keepErrors: false,
    keepDirty: false,
    keepValues: false,
    keepDefaultValues: false,
    keepIsSubmitted: true,
    keepIsSubmitSuccessful: false,
    keepTouched: false,
    keepIsValid: true,
    keepSubmitCount: true,
  } as KeepStateOptions;

  return props;
};
